/**
 * Utility functions for URL manipulation
 */

/**
 * Update URL search parameter (replace current history entry)
 * @param key - Parameter key
 * @param value - Parameter value (null to remove)
 */
export const updateURLParam = (key: string, value: string | null) => {
  const url = new URL(window.location.href);
  if (value === null) {
    url.searchParams.delete(key);
  } else {
    url.searchParams.set(key, value);
  }
  window.history.replaceState({}, '', url.toString());
};

/**
 * Push URL with updated parameter (new history entry so browser back goes to previous step)
 * @param key - Parameter key
 * @param value - Parameter value (null to remove)
 */
export const pushURLParam = (key: string, value: string | null) => {
  const url = new URL(window.location.href);
  if (value === null) {
    url.searchParams.delete(key);
  } else {
    url.searchParams.set(key, value);
  }
  window.history.pushState({}, '', url.toString());
};

/**
 * Get URL search parameter
 * @param key - Parameter key
 * @returns Parameter value or null
 */
export const getURLParam = (key: string): string | null => {
  const params = new URLSearchParams(window.location.search);
  return params.get(key);
};

